export default __webpack_public_path__ + "static/media/blog.b6b323dc.png";